import React from "react";
export function Logo() {
    return (React.createElement("svg", { className: "h-full w-full fill-current", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 195 185" },
        React.createElement("path", { d: "M25.164 81.9737C22.31 81.9737 19.998 84.2877 20 87.1417L20.028 128.458C20.03 131.309 22.341 133.619 25.192 133.619C28.046 133.619 30.359 131.304 30.357 128.451L30.328 87.1347C30.326 84.2837 28.015 81.9737 25.164 81.9737Z" }),
        React.createElement("path", { d: "M87.1367 61.3158C84.2837 61.3158 81.9707 63.6298 81.9727 66.4828L82.0017 118.128C82.0037 120.979 84.3147 123.29 87.1667 123.29C90.0197 123.29 92.3327 120.976 92.3307 118.122L92.3007 66.4778C92.2997 63.6258 89.9877 61.3158 87.1367 61.3158Z" }),
        React.createElement("path", { d: "M107.793 20C104.94 20 102.628 22.313 102.629 25.166L102.661 159.442C102.662 162.294 104.974 164.605 107.826 164.605C110.679 164.605 112.991 162.293 112.99 159.44L112.957 25.163C112.957 22.311 110.645 20 107.793 20Z" }),
        React.createElement("path", { d: "M128.451 20C125.598 20 123.286 22.313 123.287 25.166L123.319 159.442C123.32 162.294 125.632 164.605 128.484 164.605C131.337 164.605 133.649 162.293 133.648 159.44L133.615 25.163C133.615 22.311 131.303 20 128.451 20Z" }),
        React.createElement("path", { d: "M149.11 20C146.257 20 143.944 22.313 143.946 25.167L143.977 102.634C143.978 105.485 146.29 107.796 149.141 107.796C151.994 107.796 154.307 105.483 154.306 102.63L154.274 25.162C154.273 22.311 151.961 20 149.11 20Z" }),
        React.createElement("path", { d: "M169.75 40.6579C166.897 40.6579 164.585 42.9709 164.586 45.8239L164.617 138.785C164.618 141.637 166.93 143.948 169.782 143.948C172.635 143.948 174.947 141.634 174.946 138.781L174.914 45.8209C174.914 42.9689 172.602 40.6579 169.75 40.6579Z" }),
        React.createElement("path", { d: "M45.8203 61.3158C42.9673 61.3158 40.6553 63.6288 40.6563 66.4818L40.6873 159.443C40.6883 162.295 43.0003 164.606 45.8523 164.606C48.7053 164.606 51.0173 162.292 51.0163 159.439L50.9843 66.4788C50.9843 63.6268 48.6723 61.3158 45.8203 61.3158Z" }),
        React.createElement("path", { d: "M66.4785 61.3158C63.6255 61.3158 61.3135 63.6288 61.3145 66.4818L61.3455 159.443C61.3465 162.295 63.6585 164.606 66.5105 164.606C69.3635 164.606 71.6755 162.292 71.6745 159.439L71.6425 66.4788C71.6415 63.6268 69.3305 61.3158 66.4785 61.3158Z" })));
}
// export function Logo() {
//   return (
//     <div className="absolute bottom-0 right-0 h-20 w-20">
//       <svg
//         className="h-full w-full"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//         viewBox="0 0 250 250"
//       >
//         <circle cx="50" cy="55" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="50" cy="83" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="50" cy="111" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="50" cy="139" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="50" cy="167" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="50" cy="195" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="78" cy="55" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="78" cy="83" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="78" cy="111" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="78" cy="139" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="78" cy="167" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="78" cy="195" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="106" cy="55" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="106" cy="83" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="106" cy="111" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="106" cy="139" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="106" cy="167" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="106" cy="195" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="134" cy="55" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="134" cy="83" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="134" cy="111" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="162" cy="55" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="162" cy="83" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="162" cy="111" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="190" cy="55" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="190" cy="83" r="7" stroke="#838383" strokeWidth="4" />
//         <circle
//           cx="78"
//           cy="167"
//           r="7"
//           fill="#838383"
//           stroke="#838383"
//           strokeWidth="4"
//         />
//         <circle
//           cx="106"
//           cy="111"
//           r="7"
//           fill="#838383"
//           stroke="#838383"
//           strokeWidth="4"
//         />
//         <circle
//           cx="190"
//           cy="83"
//           r="7"
//           fill="#838383"
//           stroke="#838383"
//           strokeWidth="4"
//         />
//         <circle cx="190" cy="111" r="7" stroke="#838383" strokeWidth="4" />
//         <rect x="127" y="132" width="71" height="14" fill="#838383" />
//         <rect x="127" y="160" width="71" height="14" fill="#838383" />
//         <rect x="127" y="188" width="71" height="14" fill="#838383" />
//       </svg>
//     </div>
//   );
// }
// export default function Logo() {
//   return (
//     <div className="absolute bottom-0 right-0 h-20 w-20">
//       <svg
//         className="h-full w-full"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//         viewBox="0 0 250 250"
//       >
//         <circle cx="47" cy="55" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="47" cy="83" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="47" cy="111" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="47" cy="139" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="47" cy="167" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="47" cy="195" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="73" cy="55" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="73" cy="83" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="73" cy="111" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="73" cy="139" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="73" cy="167" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="73" cy="195" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="99" cy="55" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="99" cy="83" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="99" cy="111" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="99" cy="139" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="99" cy="167" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="99" cy="195" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="125" cy="55" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="125" cy="83" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="125" cy="111" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="125" cy="139" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="125" cy="167" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="125" cy="195" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="151" cy="55" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="151" cy="83" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="151" cy="111" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="151" cy="139" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="151" cy="167" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="151" cy="195" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="177" cy="55" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="177" cy="83" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="177" cy="111" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="177" cy="139" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="177" cy="167" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="177" cy="195" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="203" cy="55" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="203" cy="83" r="7" stroke="#838383" strokeWidth="4" />
//         <circle
//           cx="47"
//           cy="55"
//           r="7"
//           fill="#838383"
//           stroke="#838383"
//           strokeWidth="4"
//         />
//         <circle
//           cx="99"
//           cy="167"
//           r="7"
//           fill="#838383"
//           stroke="#838383"
//           strokeWidth="4"
//         />
//         <circle
//           cx="125"
//           cy="111"
//           r="7"
//           fill="#838383"
//           stroke="#838383"
//           strokeWidth="4"
//         />
//         <circle
//           cx="177"
//           cy="139"
//           r="7"
//           fill="#838383"
//           stroke="#838383"
//           strokeWidth="4"
//         />
//         <circle
//           cx="203"
//           cy="83"
//           r="7"
//           fill="#838383"
//           stroke="#838383"
//           strokeWidth="4"
//         />
//         <circle cx="203" cy="111" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="203" cy="139" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="203" cy="167" r="7" stroke="#838383" strokeWidth="4" />
//         <circle cx="203" cy="195" r="7" stroke="#838383" strokeWidth="4" />
//       </svg>
//     </div>
//   );
// }
